import React, { FC, ChangeEvent, ReactNode } from "react";
import { IOption } from "@evergis/ui";
import { AttributeSelectorType, AttributeType, StringSubType } from "@evergis/api";

import { NumberFormatSettings } from "./NumberFormatSettings";
import { DateFormatSettings } from "./DateFormatSettings";
import { PointFormatSettings } from "./PointFormatSettings";

import { FormStateType } from "../hooks/useAttributeFormat";
import { StringFormatSettings } from "./StringFormatSettings";

type FormatSettingsProps = {
  type: AttributeType;
  subType?: StringSubType;
  formState: FormStateType;
  onChangeFormatValue: (option: IOption[]) => void;
  onChangeFormatTime: (option: IOption[]) => void;
  onChangeNumberInput: (value: number) => void;
  onChangeFormatLabel: (evt: ChangeEvent<HTMLInputElement>) => void;
  onChangeFormatSubType?: (value: StringSubType) => void;
  toggleSelected: (name: string) => void;
  description?: string;
  attributeSelectorType?: AttributeSelectorType;
  childrenBefore?: ReactNode;
};

export const FormatSettings: FC<FormatSettingsProps> = ({
  type,
  subType,
  formState,
  attributeSelectorType,
  childrenBefore,
  onChangeFormatValue,
  onChangeFormatTime,
  onChangeNumberInput,
  onChangeFormatLabel,
  onChangeFormatSubType,
  toggleSelected,
  children,
}) => {
  switch (type) {
    case AttributeType.Double:
    case AttributeType.Int32:
    case AttributeType.Int64:
    case AttributeType.Polyline:
    case AttributeType.MultiPolygon:
      return (
        <NumberFormatSettings
          type={type}
          formState={formState}
          attributeSelectorType={attributeSelectorType}
          childrenBefore={childrenBefore}
          onChangeFormatValue={onChangeFormatValue}
          onChangeNumberInput={onChangeNumberInput}
          onChangeFormatLabel={onChangeFormatLabel}
          toggleSelected={toggleSelected}
        >
          {children}
        </NumberFormatSettings>
      );
    case AttributeType.DateTime:
      return (
        <DateFormatSettings
          type={type}
          formState={formState}
          attributeSelectorType={attributeSelectorType}
          childrenBefore={childrenBefore}
          onChangeFormatValue={onChangeFormatValue}
          onChangeFormatTime={onChangeFormatTime}
          toggleSelected={toggleSelected}
        >
          {children}
        </DateFormatSettings>
      );
    case AttributeType.Point:
      return (
        <PointFormatSettings
          type={type}
          formState={formState}
          attributeSelectorType={attributeSelectorType}
          childrenBefore={childrenBefore}
          onChangeFormatValue={onChangeFormatValue}
          onChangeNumberInput={onChangeNumberInput}
        >
          {children}
        </PointFormatSettings>
      );

    case AttributeType.String:
      return (
        <StringFormatSettings
          type={type}
          subType={subType}
          attributeSelectorType={attributeSelectorType}
          childrenBefore={childrenBefore}
          onChangeFormatSubType={onChangeFormatSubType}
        >
          {children}
        </StringFormatSettings>
      );

    default:
      return null;
  }
};
